// extracted by mini-css-extract-plugin
export default {"popover-additional":"LhqBd","active":"S1nAk","drawer":"R102G","drawer-mobile":"ZZMKS","additional-info-wrapper":"ISzGq","main":"wB6af"};